module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr auto",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings,
      "ombrelli": _vm.ombrelli,
      "getOmbrelli": _vm.getOmbrelli
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid toolbox"
  }, [_c('el-button-group', [(!_vm.bulkedit) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia struttura spiaggia",
      "placement": "bottom"
    }
  }, [(!_vm.setgrid) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setgrid = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  })]) : _vm._e(), _vm._v(" "), (_vm.setgrid) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.setgrid = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-th"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.bulkedit) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Cambia impostazioni Ombrelloni",
      "placement": "bottom"
    }
  }, [_c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.show('bulkombrellosettings'), _vm.disableSelection()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-edit"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Abilita Multi-Edit",
      "placement": "bottom"
    }
  }, [(!_vm.bulkedit) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.enableSelection
    }
  }, [_c('i', {
    staticClass: "fas fa-lock"
  })]) : _vm._e(), _vm._v(" "), (_vm.bulkedit) ? _c('el-button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.destroySelection()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-unlock"
  })]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "test",
    staticStyle: {
      "display": "grid",
      "justify-items": "center",
      "align-content": "start",
      "overflow": "auto",
      "height": "100vh",
      "padding": "0px"
    }
  }, [(_vm.setgrid) ? _c('div', {
    staticClass: "grid setgrid"
  }, [_c('el-form', [(_vm.hotel && !_vm.loading) ? _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "column",
      "grid-column-gap": "24px",
      "justify-content": "space-between"
    }
  }, [_c('div', [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Righe in Spiaggia")]), _vm._v(" "), _c('el-form-item', [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    on: {
      "change": _vm.changeGrid
    },
    model: {
      value: (_vm.hotel.rows),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "rows", $$v)
      },
      expression: "hotel.rows"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v("Colonne in Spiaggia")]), _vm._v(" "), _c('el-form-item', [_c('el-input-number', {
    attrs: {
      "min": 1
    },
    on: {
      "change": _vm.changeGrid
    },
    model: {
      value: (_vm.hotel.cols),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "cols", $$v)
      },
      expression: "hotel.cols"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "grid-auto-flow": "row"
    }
  }, [_c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveGrid
    }
  }, [_vm._v("Salve struttura spiaggia")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "boundary"
  }, [(_vm.hotel && !_vm.loading) ? _c('div', {
    staticClass: "grid editgrid",
    staticStyle: {
      "padding": "96px"
    },
    style: (_vm.gridstyle)
  }, [_vm._l((_vm.ombrelli), function(ombrello, index) {
    return (!_vm.firstreset) ? _c('div', {
      staticClass: "grid ombrello"
    }, [_c('div', {
      staticClass: "grid seat free",
      class: {
        nonvisible: !ombrello.visible
      },
      attrs: {
        "id": ombrello._id,
        "data-item": ombrello.ombrid,
        "data-id": ombrello._id
      }
    }, [_c('div', [_vm._v("\n              " + _vm._s(ombrello.ombrid) + "\n              ")]), _vm._v(" "), (!_vm.bulkedit) ? _c('div', {
      staticClass: "options"
    }, [(!ombrello.visible) ? _c('el-checkbox', {
      attrs: {
        "label": "visible"
      },
      model: {
        value: (ombrello.visible),
        callback: function($$v) {
          _vm.$set(ombrello, "visible", $$v)
        },
        expression: "ombrello.visible"
      }
    }, [_c('i', {
      staticClass: "fas fa-eye-slash"
    })]) : _vm._e(), _vm._v(" "), (ombrello.visible) ? _c('el-checkbox', {
      attrs: {
        "label": "visible"
      },
      model: {
        value: (ombrello.visible),
        callback: function($$v) {
          _vm.$set(ombrello, "visible", $$v)
        },
        expression: "ombrello.visible"
      }
    }, [_c('i', {
      staticClass: "fas fa-eye"
    })]) : _vm._e(), _vm._v(" "), (!ombrello.cashable && _vm.hotel.cashier) ? _c('el-checkbox', {
      attrs: {
        "label": "cashable"
      },
      model: {
        value: (ombrello.cashable),
        callback: function($$v) {
          _vm.$set(ombrello, "cashable", $$v)
        },
        expression: "ombrello.cashable"
      }
    }, [_c('i', {
      staticClass: "fab fa-creative-commons-nc-eu"
    })]) : _vm._e(), _vm._v(" "), (ombrello.cashable && _vm.hotel.cashier) ? _c('el-checkbox', {
      attrs: {
        "label": "cashable"
      },
      model: {
        value: (ombrello.cashable),
        callback: function($$v) {
          _vm.$set(ombrello, "cashable", $$v)
        },
        expression: "ombrello.cashable"
      }
    }, [_c('i', {
      staticClass: "fas fa-euro-sign"
    })]) : _vm._e(), _vm._v(" "), _c('i', {
      staticClass: "fas fa-cash-register",
      on: {
        "click": function($event) {
          return _vm.show('ombrellosettings', ombrello)
        }
      }
    })], 1) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.newombrelli), function(ombrello, index) {
    return (_vm.firstreset) ? _c('div', {
      staticClass: "grid ombrello"
    }, [_c('div', {
      staticClass: "grid seat free",
      attrs: {
        "id": ombrello._id
      }
    }, [_c('span', [_vm._v(_vm._s(ombrello.ombrid))])])]) : _vm._e()
  })], 2) : _vm._e()])]), _vm._v(" "), (!_vm.loading && _vm.hotel) ? _c('modal', {
    attrs: {
      "name": "ombrellosettings",
      "width": "50%",
      "minWidth": 360,
      "maxWidth": 1040,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    }
  }, [_c('div', {
    staticClass: "grid ombrellosettings"
  }, [_c('div', {
    staticClass: "grid seasons"
  }, [_c('h1', [_vm._v(_vm._s(_vm.ombrellos.ombrid) + " "), _vm._l((_vm.selectedOmbrellos), function(ombrello) {
    return _c('span', [_vm._v(_vm._s(ombrello))])
  })], 2), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.ombrellos.seasons))]), _vm._v(" "), _c('el-form', _vm._l((_vm.hotel.seasons), function(season) {
    return _c('div', {
      staticClass: "grid season"
    }, [_c('span', [_vm._v(_vm._s(season.name))]), _vm._v(" "), _c('div', {
      staticClass: "grid data"
    }, [_c('span', [_c('small', [_vm._v(_vm._s(season.start) + " > " + _vm._s(season.end))])]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-edit",
      on: {
        "click": function($event) {
          return _vm.editseason(season, _vm.index)
        }
      }
    })])])
  }), 0)], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.hotel) ? _c('modal', {
    attrs: {
      "name": "bulkombrellosettings",
      "width": "70%",
      "minWidth": 360,
      "maxWidth": 1040,
      "height": "auto",
      "adaptive": true,
      "scrollable": ""
    },
    on: {
      "before-close": _vm.beforeClose
    }
  }, [_c('div', {
    staticClass: "grid bulkombrellosettings"
  }, [(_vm.selectedOmbrellos.length === 0) ? _c('span', [_vm._v("Nessun Ombrellone selezionato")]) : _vm._e(), _vm._v(" "), (_vm.selectedOmbrellos.length >= 1) ? _c('div', {
    staticClass: "grid selectedombrellos"
  }, _vm._l((_vm.selectedOmbrellos), function(ombrello) {
    return _c('span', [_vm._v(_vm._s(ombrello.ombrid))])
  }), 0) : _vm._e(), _vm._v(" "), _c('el-form', [_c('div', {
    staticClass: "grid seasons"
  }, [_c('span', [_c('strong', [_vm._v("Cambia impostazioni per tutti gli ombrelloni selezionati")])]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _vm._l((_vm.newseasons), function(season, index) {
    return _c('div', {
      staticClass: "grid season"
    }, [_c('span', [_vm._v(_vm._s(season.name))]), _vm._v(" "), _c('div', {
      staticClass: "grid data"
    }, [_c('span', [_c('small', [_vm._v(_vm._s(season.start) + " > " + _vm._s(season.end))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("€ " + _vm._s(season.amount))])]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-edit",
      on: {
        "click": function($event) {
          return _vm.editseason(season, index)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), (_vm.hotel.cashier) ? _c('div', {
    staticClass: "grid setting"
  }, [_c('span', [_vm._v("Ombrelloni a pagamento")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.ombrellos.cashable),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "cashable", $$v)
      },
      expression: "ombrellos.cashable"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "grid setting"
  }, [_c('span', [_vm._v("Ombrelloni visibili")]), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.ombrellos.visible),
      callback: function($$v) {
        _vm.$set(_vm.ombrellos, "visible", $$v)
      },
      expression: "ombrellos.visible"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveBulk
    }
  }, [_vm._v("Salva Impostazioni")])], 2)]), _vm._v(" "), (_vm.updateseason) ? _c('div', {
    staticClass: "grid addseason"
  }, [_c('span', [_c('strong', [_vm._v("Update stagione: " + _vm._s(_vm.newseason.name))])]), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "Prezzo base ombrellone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Prezzo ombrellone",
      "name": "ombrellone"
    },
    model: {
      value: (_vm.newseason.amount),
      callback: function($$v) {
        _vm.$set(_vm.newseason, "amount", $$v)
      },
      expression: "newseason.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("€")])], 2)], 1), _vm._v(" "), _vm._l((_vm.newseason.items), function(item) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": 'Prezzo base ' + item.name
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Prezzo oggetto",
        "name": "price"
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("€")])], 2)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    staticClass: "btn btn-green",
    on: {
      "click": function($event) {
        return _vm.bulkUpdateseason()
      }
    }
  }, [_vm._v("salva impostazioni stagione")])], 1)])], 2)], 1) : _vm._e()], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7145ad17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Editgrid.vue
// module id = 652
// module chunks = 1